import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@ui/components/ui/dialog';
import Button from '@ui/components/ui/loading-button';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface RemoveReportModalProps {
  onRemove: () => void;
  show: boolean;
  onHide: () => void;
}

const RemoveReportModal = ({ show = false, onHide, onRemove }: RemoveReportModalProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <Dialog open={show} onOpenChange={open => !open && onHide()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('titles.deleteReport')}</DialogTitle>
        </DialogHeader>
        <p>{t('alerts.deletePopup')}</p>
        <div className="mt-6 flex flex-wrap justify-end gap-4">
          <Button variant="outlined" onClick={onHide} className="!border-primary !px-9 !py-3 !text-primary">
            {t('actions.cancel')}
          </Button>
          <Button variant="contained" className="!bg-primary !px-9 !py-3" onClick={onRemove}>
            {t('actions.delete')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveReportModal;
